/* RESPONSIBLE TEAM: team-reporting */

import type { VisualizationType } from '@/features/reporting-charts/types';

/**
 * Chart types fully implemented in the new reporting-charts system.
 * Add types here as they are completed and tested.
 *
 * Migration order (per Implementation Plan.md):
 * 1. counter ✓
 * 2. line, bar, area, horizontal-bar, column-line (series) ✓
 * 3. tabular, data-table
 * 4. donut
 * 5. heatmap ✓
 */
export const SUPPORTED_CHART_TYPES: ReadonlySet<VisualizationType> = new Set([
  'counter',
  'bar',
  'horizontal-bar',
  'line',
  'area',
  'column-line',
  'heatmap',
  'donut',
  'tabular',
]);

export function isChartTypeSupported(type: VisualizationType): boolean {
  return SUPPORTED_CHART_TYPES.has(type);
}
